import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { InformationEffects } from '@core/store/effects/information.effects';
import { LoginMessagesEffects } from '@core/store/effects/login-messages.effects';
import { UserLoginMessagesEffects } from '@core/store/effects/user-login-messages.effects';
import { UserInformationEffects } from '@core/store/effects/user-information.effects';
import { FormsEffects } from '@core/store/effects/forms.effects';
import { FeedEffects } from '@core/store/effects/feed.effects';

export const effects = [
    InformationEffects, 
    LoginMessagesEffects, 
    UserLoginMessagesEffects, 
    UserInformationEffects, 
    FormsEffects,
    FeedEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class InformationEffectsModule {}
